// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel .control-arrow,
.carousel.carousel-slider .control-arrow {
  -webkit-transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -ms-transition: all 0.25s ease-in;
  -o-transition: all 0.25s ease-in;
  transition: all 0.25s ease-in;
  opacity: 0.4;
  filter: alpha(opacity=40);
  position: absolute;
  z-index: 2;
  top: 20px;
  background: none;
  border: 0;
  font-size: 32px;
  cursor: pointer;
}
.carousel .control-arrow:focus,
.carousel .control-arrow:hover {
  opacity: 1;
  filter: alpha(opacity=100);
}
.carousel .control-arrow:before,
.carousel.carousel-slider .control-arrow:before {
  margin: 0 5px;
  display: inline-block;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  content: '';
}
.carousel .control-disabled.control-arrow {
  opacity: 0;
  filter: alpha(opacity=0);
  cursor: inherit;
  display: none;
}
.carousel .control-prev.control-arrow {
  left: 0;
}
.carousel .control-prev.control-arrow:before {
  border-right: 8px solid #fff;
}
.carousel .control-next.control-arrow {
  right: 0;
}
.carousel .control-next.control-arrow:before {
  border-left: 8px solid #fff;
}
.carousel-root {
  outline: none;
}
.carousel {
  position: relative;
  width: 100%;
}
.carousel * {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.carousel img {
  width: 100%;
  display: inline-block;
  pointer-events: none;
}
.carousel .carousel {
  position: relative;
}
.carousel .control-arrow {
  outline: 0;
  border: 0;
  background: none;
  top: 50%;
  margin-top: -13px;
  font-size: 18px;
}
.carousel .thumbs-wrapper {
  margin: 20px;
  overflow: hidden;
}
.carousel .thumbs {
  -webkit-transition: all 0.15s ease-in;
  -moz-transition: all 0.15s ease-in;
  -ms-transition: all 0.15s ease-in;
  -o-transition: all 0.15s ease-in;
  transition: all 0.15s ease-in;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  position: relative;
  list-style: none;
  white-space: nowrap;
}
.carousel .thumb {
  -webkit-transition: border 0.15s ease-in;
  -moz-transition: border 0.15s ease-in;
  -ms-transition: border 0.15s ease-in;
  -o-transition: border 0.15s ease-in;
  transition: border 0.15s ease-in;
  display: inline-block;
  margin-right: 6px;
  white-space: nowrap;
  overflow: hidden;
  border: 3px solid #fff;
  padding: 2px;
}
.carousel .thumb:focus {
  border: 3px solid #ccc;
  outline: none;
}
.carousel .thumb.selected,
.carousel .thumb:hover {
  border: 3px solid #333;
}
.carousel .thumb img {
  vertical-align: top;
}
.carousel.carousel-slider {
  position: relative;
  margin: 0;
  overflow: hidden;
}
.carousel.carousel-slider .control-arrow {
  top: 0;
  color: #fff;
  font-size: 26px;
  bottom: 0;
  margin-top: 0;
  padding: 5px;
}
.carousel.carousel-slider .control-arrow:hover {
  background: rgba(0, 0, 0, 0.2);
}
.carousel .slider-wrapper {
  overflow: hidden;
  margin: auto;
  width: 100%;
  -webkit-transition: height 0.15s ease-in;
  -moz-transition: height 0.15s ease-in;
  -ms-transition: height 0.15s ease-in;
  -o-transition: height 0.15s ease-in;
  transition: height 0.15s ease-in;
}
.carousel .slider-wrapper.axis-horizontal .slider {
  -ms-box-orient: horizontal;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -moz-flex;
  display: -webkit-flex;
  display: flex;
}
.carousel .slider-wrapper.axis-horizontal .slider .slide {
  flex-direction: column;
  flex-flow: column;
}
.carousel .slider-wrapper.axis-vertical {
  -ms-box-orient: horizontal;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -moz-flex;
  display: -webkit-flex;
  display: flex;
}
.carousel .slider-wrapper.axis-vertical .slider {
  -webkit-flex-direction: column;
  flex-direction: column;
}
.carousel .slider {
  margin: 0;
  padding: 0;
  position: relative;
  list-style: none;
  width: 100%;
}
.carousel .slider.animated {
  -webkit-transition: all 0.35s ease-in-out;
  -moz-transition: all 0.35s ease-in-out;
  -ms-transition: all 0.35s ease-in-out;
  -o-transition: all 0.35s ease-in-out;
  transition: all 0.35s ease-in-out;
}
.carousel .slide {
  min-width: 100%;
  margin: 0;
  position: relative;
  text-align: center;
}
.carousel .slide img {
  width: 100%;
  vertical-align: top;
  border: 0;
}
.carousel .slide iframe {
  display: inline-block;
  width: calc(100% - 80px);
  margin: 0 40px 40px;
  border: 0;
}
.carousel .slide .legend {
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  position: absolute;
  bottom: 40px;
  left: 50%;
  margin-left: -45%;
  width: 90%;
  border-radius: 10px;
  background: #000;
  color: #fff;
  padding: 10px;
  font-size: 12px;
  text-align: center;
  opacity: 0.25;
  -webkit-transition: opacity 0.35s ease-in-out;
  -moz-transition: opacity 0.35s ease-in-out;
  -ms-transition: opacity 0.35s ease-in-out;
  -o-transition: opacity 0.35s ease-in-out;
  transition: opacity 0.35s ease-in-out;
}
.carousel .control-dots {
  position: absolute;
  bottom: 0;
  margin: 10px 0;
  padding: 0;
  text-align: center;
  width: 100%;
  z-index: 1;
}
@media (min-width: 960px) {
  .carousel .control-dots {
    bottom: 0;
  }
}
.carousel .control-dots .dot {
  -webkit-transition: opacity 0.25s ease-in;
  -moz-transition: opacity 0.25s ease-in;
  -ms-transition: opacity 0.25s ease-in;
  -o-transition: opacity 0.25s ease-in;
  transition: opacity 0.25s ease-in;
  opacity: 0.3;
  filter: alpha(opacity=30);
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.9);
  background: #fff;
  border-radius: 50%;
  width: 8px;
  height: 8px;
  cursor: pointer;
  display: inline-block;
  margin: 0 8px;
}
.carousel .control-dots .dot.selected,
.carousel .control-dots .dot:hover {
  opacity: 1;
  filter: alpha(opacity=100);
}
.carousel .carousel-status {
  position: absolute;
  top: 0;
  right: 0;
  padding: 5px;
  font-size: 10px;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.9);
  color: #fff;
}
.carousel:hover .slide .legend {
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./node_modules/react-responsive-carousel/lib/styles/carousel.min.css"],"names":[],"mappings":"AAAA;;EAAkE,qCAAA;EAAoC,kCAAA;EAAiC,iCAAA;EAAgC,gCAAA;EAA+B,6BAAA;EAA4B,YAAA;EAAW,yBAAA;EAAyB,kBAAA;EAAkB,UAAA;EAAU,SAAA;EAAS,gBAAA;EAAgB,SAAA;EAAS,eAAA;EAAe,eAAA;AAgBnV;AAhBkW;;EAA8D,UAAA;EAAU,0BAAA;AAqB1a;AArBoc;;EAAgF,aAAA;EAAa,qBAAA;EAAqB,iCAAA;EAAiC,oCAAA;EAAoC,WAAA;AA6B3nB;AA7BsoB;EAA0C,UAAA;EAAU,wBAAA;EAAwB,eAAA;EAAe,aAAA;AAmCjuB;AAnC8uB;EAAsC,OAAA;AAsCpxB;AAtC2xB;EAA6C,4BAAA;AAyCx0B;AAzCo2B;EAAsC,QAAA;AA4C14B;AA5Ck5B;EAA6C,2BAAA;AA+C/7B;AA/C09B;EAAe,aAAA;AAkDz+B;AAlDs/B;EAAU,kBAAA;EAAkB,WAAA;AAsDlhC;AAtD6hC;EAAY,8BAAA;EAA8B,2BAAA;EAA2B,sBAAA;AA2DlmC;AA3DwnC;EAAc,WAAA;EAAW,qBAAA;EAAqB,oBAAA;AAgEtqC;AAhE0rC;EAAoB,kBAAA;AAmE9sC;AAnEguC;EAAyB,UAAA;EAAU,SAAA;EAAS,gBAAA;EAAgB,QAAA;EAAQ,iBAAA;EAAiB,eAAA;AA2ErzC;AA3Eo0C;EAA0B,YAAA;EAAY,gBAAA;AA+E12C;AA/E03C;EAAkB,qCAAA;EAAoC,kCAAA;EAAiC,iCAAA;EAAgC,gCAAA;EAA+B,6BAAA;EAA4B,uCAAA;EAAuC,oCAAA;EAAoC,mCAAA;EAAmC,kCAAA;EAAkC,+BAAA;EAA+B,kBAAA;EAAkB,gBAAA;EAAgB,mBAAA;AA8F7vD;AA9FgxD;EAAiB,wCAAA;EAAuC,qCAAA;EAAoC,oCAAA;EAAmC,mCAAA;EAAkC,gCAAA;EAA+B,qBAAA;EAAqB,iBAAA;EAAiB,mBAAA;EAAmB,gBAAA;EAAgB,sBAAA;EAAsB,YAAA;AA2G/iE;AA3G2jE;EAAuB,sBAAA;EAAsB,aAAA;AA+GxmE;AA/GqnE;;EAAiD,sBAAA;AAmHtqE;AAnH4rE;EAAqB,mBAAA;AAsHjtE;AAtHouE;EAA0B,kBAAA;EAAkB,SAAA;EAAS,gBAAA;AA2HzxE;AA3HyyE;EAAyC,MAAA;EAAM,WAAA;EAAW,eAAA;EAAe,SAAA;EAAS,aAAA;EAAa,YAAA;AAmIx4E;AAnIo5E;EAA+C,8BAAA;AAsIn8E;AAtI89E;EAA0B,gBAAA;EAAgB,YAAA;EAAY,WAAA;EAAW,wCAAA;EAAuC,qCAAA;EAAoC,oCAAA;EAAmC,mCAAA;EAAkC,gCAAA;AAgJ/qF;AAhJ8sF;EAAkD,0BAAA;EAA0B,oBAAA;EAAoB,iBAAA;EAAiB,oBAAA;EAAoB,kBAAA;EAAkB,qBAAA;EAAqB,aAAA;AAyJ13F;AAzJu4F;EAAyD,sBAAA;EAAsB,iBAAA;AA6Jt9F;AA7Ju+F;EAAwC,0BAAA;EAA0B,oBAAA;EAAoB,iBAAA;EAAiB,oBAAA;EAAoB,kBAAA;EAAkB,qBAAA;EAAqB,aAAA;AAsKzoG;AAtKspG;EAAgD,8BAAA;EAA8B,sBAAA;AA0KpuG;AA1K0vG;EAAkB,SAAA;EAAS,UAAA;EAAU,kBAAA;EAAkB,gBAAA;EAAgB,WAAA;AAiLj0G;AAjL40G;EAA2B,yCAAA;EAAwC,sCAAA;EAAqC,qCAAA;EAAoC,oCAAA;EAAmC,iCAAA;AAwL3/G;AAxL2hH;EAAiB,eAAA;EAAe,SAAA;EAAS,kBAAA;EAAkB,kBAAA;AA8LtlH;AA9LwmH;EAAqB,WAAA;EAAW,mBAAA;EAAmB,SAAA;AAmM3pH;AAnMoqH;EAAwB,qBAAA;EAAqB,wBAAA;EAAwB,mBAAA;EAAmB,SAAA;AAyM5vH;AAzMqwH;EAAyB,wCAAA;EAAuC,qCAAA;EAAoC,oCAAA;EAAmC,mCAAA;EAAkC,gCAAA;EAA+B,kBAAA;EAAkB,YAAA;EAAY,SAAA;EAAS,iBAAA;EAAiB,UAAA;EAAU,mBAAA;EAAmB,gBAAA;EAAgB,WAAA;EAAW,aAAA;EAAa,eAAA;EAAe,kBAAA;EAAkB,aAAA;EAAa,6CAAA;EAA4C,0CAAA;EAAyC,yCAAA;EAAwC,wCAAA;EAAuC,qCAAA;AAiO5xI;AAjOg0I;EAAwB,kBAAA;EAAkB,SAAA;EAAS,cAAA;EAAc,UAAA;EAAU,kBAAA;EAAkB,WAAA;EAAW,UAAA;AA0Ox6I;AA1Ok7I;EAA0B;IAAwB,SAAA;EA8Ol+I;AACF;AA/O8+I;EAA6B,yCAAA;EAAwC,sCAAA;EAAqC,qCAAA;EAAoC,oCAAA;EAAmC,iCAAA;EAAgC,YAAA;EAAW,yBAAA;EAAyB,0CAAA;EAAuC,gBAAA;EAAgB,kBAAA;EAAkB,UAAA;EAAU,WAAA;EAAW,eAAA;EAAe,qBAAA;EAAqB,aAAA;AAgQr2J;AAhQk3J;;EAAyE,UAAA;EAAU,0BAAA;AAqQr8J;AArQ+9J;EAA2B,kBAAA;EAAkB,MAAA;EAAM,QAAA;EAAQ,YAAA;EAAY,eAAA;EAAe,2CAAA;EAAwC,WAAA;AA8Q7lK;AA9QwmK;EAA+B,UAAA;AAiRvoK","sourcesContent":[".carousel .control-arrow,.carousel.carousel-slider .control-arrow{-webkit-transition:all .25s ease-in;-moz-transition:all .25s ease-in;-ms-transition:all .25s ease-in;-o-transition:all .25s ease-in;transition:all .25s ease-in;opacity:.4;filter:alpha(opacity=40);position:absolute;z-index:2;top:20px;background:none;border:0;font-size:32px;cursor:pointer}.carousel .control-arrow:focus,.carousel .control-arrow:hover{opacity:1;filter:alpha(opacity=100)}.carousel .control-arrow:before,.carousel.carousel-slider .control-arrow:before{margin:0 5px;display:inline-block;border-top:8px solid transparent;border-bottom:8px solid transparent;content:''}.carousel .control-disabled.control-arrow{opacity:0;filter:alpha(opacity=0);cursor:inherit;display:none}.carousel .control-prev.control-arrow{left:0}.carousel .control-prev.control-arrow:before{border-right:8px solid #fff}.carousel .control-next.control-arrow{right:0}.carousel .control-next.control-arrow:before{border-left:8px solid #fff}.carousel-root{outline:none}.carousel{position:relative;width:100%}.carousel *{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.carousel img{width:100%;display:inline-block;pointer-events:none}.carousel .carousel{position:relative}.carousel .control-arrow{outline:0;border:0;background:none;top:50%;margin-top:-13px;font-size:18px}.carousel .thumbs-wrapper{margin:20px;overflow:hidden}.carousel .thumbs{-webkit-transition:all .15s ease-in;-moz-transition:all .15s ease-in;-ms-transition:all .15s ease-in;-o-transition:all .15s ease-in;transition:all .15s ease-in;-webkit-transform:translate3d(0, 0, 0);-moz-transform:translate3d(0, 0, 0);-ms-transform:translate3d(0, 0, 0);-o-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0);position:relative;list-style:none;white-space:nowrap}.carousel .thumb{-webkit-transition:border .15s ease-in;-moz-transition:border .15s ease-in;-ms-transition:border .15s ease-in;-o-transition:border .15s ease-in;transition:border .15s ease-in;display:inline-block;margin-right:6px;white-space:nowrap;overflow:hidden;border:3px solid #fff;padding:2px}.carousel .thumb:focus{border:3px solid #ccc;outline:none}.carousel .thumb.selected,.carousel .thumb:hover{border:3px solid #333}.carousel .thumb img{vertical-align:top}.carousel.carousel-slider{position:relative;margin:0;overflow:hidden}.carousel.carousel-slider .control-arrow{top:0;color:#fff;font-size:26px;bottom:0;margin-top:0;padding:5px}.carousel.carousel-slider .control-arrow:hover{background:rgba(0,0,0,0.2)}.carousel .slider-wrapper{overflow:hidden;margin:auto;width:100%;-webkit-transition:height .15s ease-in;-moz-transition:height .15s ease-in;-ms-transition:height .15s ease-in;-o-transition:height .15s ease-in;transition:height .15s ease-in}.carousel .slider-wrapper.axis-horizontal .slider{-ms-box-orient:horizontal;display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:-moz-flex;display:-webkit-flex;display:flex}.carousel .slider-wrapper.axis-horizontal .slider .slide{flex-direction:column;flex-flow:column}.carousel .slider-wrapper.axis-vertical{-ms-box-orient:horizontal;display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:-moz-flex;display:-webkit-flex;display:flex}.carousel .slider-wrapper.axis-vertical .slider{-webkit-flex-direction:column;flex-direction:column}.carousel .slider{margin:0;padding:0;position:relative;list-style:none;width:100%}.carousel .slider.animated{-webkit-transition:all .35s ease-in-out;-moz-transition:all .35s ease-in-out;-ms-transition:all .35s ease-in-out;-o-transition:all .35s ease-in-out;transition:all .35s ease-in-out}.carousel .slide{min-width:100%;margin:0;position:relative;text-align:center}.carousel .slide img{width:100%;vertical-align:top;border:0}.carousel .slide iframe{display:inline-block;width:calc(100% - 80px);margin:0 40px 40px;border:0}.carousel .slide .legend{-webkit-transition:all .5s ease-in-out;-moz-transition:all .5s ease-in-out;-ms-transition:all .5s ease-in-out;-o-transition:all .5s ease-in-out;transition:all .5s ease-in-out;position:absolute;bottom:40px;left:50%;margin-left:-45%;width:90%;border-radius:10px;background:#000;color:#fff;padding:10px;font-size:12px;text-align:center;opacity:0.25;-webkit-transition:opacity .35s ease-in-out;-moz-transition:opacity .35s ease-in-out;-ms-transition:opacity .35s ease-in-out;-o-transition:opacity .35s ease-in-out;transition:opacity .35s ease-in-out}.carousel .control-dots{position:absolute;bottom:0;margin:10px 0;padding:0;text-align:center;width:100%;z-index:1}@media (min-width: 960px){.carousel .control-dots{bottom:0}}.carousel .control-dots .dot{-webkit-transition:opacity .25s ease-in;-moz-transition:opacity .25s ease-in;-ms-transition:opacity .25s ease-in;-o-transition:opacity .25s ease-in;transition:opacity .25s ease-in;opacity:.3;filter:alpha(opacity=30);box-shadow:1px 1px 2px rgba(0,0,0,0.9);background:#fff;border-radius:50%;width:8px;height:8px;cursor:pointer;display:inline-block;margin:0 8px}.carousel .control-dots .dot.selected,.carousel .control-dots .dot:hover{opacity:1;filter:alpha(opacity=100)}.carousel .carousel-status{position:absolute;top:0;right:0;padding:5px;font-size:10px;text-shadow:1px 1px 1px rgba(0,0,0,0.9);color:#fff}.carousel:hover .slide .legend{opacity:1}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
